import React from 'react';
import { Menu } from '@milanote/roma';
import { GridListItem } from 'react-aria-components';
import { Plus } from '@untitledui/icons';

import { CREATE_LABEL } from '../hooks/useLabelListSelection';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';

type Props = {
    searchString: string;
};

const CreateLabelListItem: React.FC<Props> = ({ searchString }) => {
    const translate = useTranslator('popup', 'labels.menu');

    if (!searchString) return null;

    return (
        <GridListItem
            id={CREATE_LABEL}
            textValue={searchString}
            className="CreateLabelListItem w-full py-1 outline-hidden"
        >
            {(state) => (
                <Menu.Base.ItemStructured
                    leading={
                        /* have to manually add some margin to align with the checkboxes below */
                        <div data-icon="leading" className="mx-0.5">
                            <Plus />
                        </div>
                    }
                    label={translate('createLabel', { searchString })}
                    isSelected={state.isSelected}
                    isDisabled={state.isDisabled}
                    isFocused={state.isFocused}
                    isFocusVisible={state.isFocusVisible}
                    isHovered={state.isHovered}
                    className="mx-0.5"
                    size="sm"
                />
            )}
        </GridListItem>
    );
};

export default CreateLabelListItem;
